var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("audio", {
    ref: "audio",
    attrs: { src: _vm.src, preload: "auto" },
    on: { timeupdate: _vm.checkAudioLoop },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }